import React, { useEffect, useState, useContext } from "react";
import ApprovalRequestsList from "./ApprovalRequestsList";
import { Card } from "reactstrap";
import FinanceApprovalPageHeader from "../../../views/pages/manage/unAssigned/studentFinanceApproval/components/ApprovalPageHeader";
import { checkPermission, fetchAllPostPromisedData, getDropdownIdsFromSelectArray } from "../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../views/pages/manage/common/constant";
import { approverActionAndDispValueMapping, getDropdowns, getRequests, getRoleId, searchInputOptions, updateApprovalRequests } from "./utils";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { useHistory } from "react-router-dom";
import Filters from "./Filters";
import { getConfigs } from "../transferSetup/transferApprovalConfig/services";
import { PermissionContext } from "../../../appContext";
import ApprovalSentSuccessDialog from "../../../views/pages/manage/unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog";
import { getAppliedFilterCount } from "../components/searchStudent/studentTransfersListing/utils";

const TransferApproval = ({ userPermissions }) => {

  const permissions = useContext(PermissionContext);

  const [approvalRequests, setApprovalRequests] = useState([]);
  const [dropdownData, setDropdownData] = useState({});
  const [userRoleId, setUserRoleId] = useState();
  const [transferApprovalConfigs, setTransferApprovalConfigs] = useState([]);
  const [approvalActionSuccessDialogOpen, setApprovalActionSuccessDialogOpen] = useState(false);
  const [approvalActionSuccessDialogInfo, setApprovalActionSuccessDialogInfo] = useState({});

  const history = useHistory();

  const isApproverPermission = checkPermission(userPermissions, "A");

  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    currPageNo: 0,
    currPageSize: 50,
    totalRecords: 0
  })



  const getApprovalRequests = async ({
    filters = filterForm,
    pageNo = paginationInfo?.currPageNo,
    pageSize = paginationInfo?.currPageSize,
    dropdowns = dropdownData,
    roleId = userRoleId,
    approvalConfigs = transferApprovalConfigs
  }) => {
    try {

      setLoading(true);
      const resp = await getRequests({ pageNo, pageSize, filters, dropdowns });

      if (resp?.code === 200) {

        const { totalRecords, transferDetailsDtoList, currentPage } = resp?.data;
        const updatedRequests = updateApprovalRequests(transferDetailsDtoList, dropdowns, roleId, approvalConfigs);

        setApprovalRequests(updatedRequests);

        setPaginationInfo(prev => ({
          ...prev,
          totalRecords,
          currPageNo: currentPage,
          currPageSize: pageSize
        }))

        setFilterForm({
          ...filters,
          appliedFilterCount : getAppliedFilterCount(filters, ['psid', 'applicationId', 'studentName'])
      });
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const updateStatus = async ({
    applicationId,
    approvalAction,
    remark = "",
    psid,
    transferReqNo
  }) => {
    try {
      setLoading(true);
      const reqObj = { approvalAction, remarks: remark, applicationId };
      const resp = await fetchAllPostPromisedData(
        `${endpoint.transferApproval.updateStatus}`,
        reqObj
      );
      if (resp?.code === 200) {
        // successToast("Request completed successfully!");
        const actionDispValue = approverActionAndDispValueMapping[approvalAction];
        setApprovalActionSuccessDialogOpen(true);
        setApprovalActionSuccessDialogInfo({
          heading: `Transfer request no. ${transferReqNo} has been ${actionDispValue}.`,
          subHeading: `Request has been ${actionDispValue} for PSID ${psid}.`
        })
        await getApprovalRequests({});
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const handleFilterForm = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };


  const init = async () => {
    try {
      setLoading(true);
      const dropdowns = await getDropdowns();
      const roleId = await getRoleId(permissions?.roleType);
      const approvalConfigs = (await getConfigs({businessAreas : getDropdownIdsFromSelectArray(dropdowns?.businessAreas)}))?.data ?? [];
      setDropdownData(dropdowns);
      setUserRoleId(roleId);
      setTransferApprovalConfigs(approvalConfigs);
      getApprovalRequests({ dropdowns, roleId, approvalConfigs });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    permissions && init();
  }, [permissions]);

  return (
    <>
      <FinanceApprovalPageHeader
        heading="Student transfer approvals"
        subHeading="Here you can approve the transfer requests of students"
      />

      <Card className="m-3 px-2 pt-3">
        <div className="d-flex justify-content-between">
          <div>
            <BackArrow
              className="mr-2 cursor"
              onClick={() => history.goBack()}
            />
            <h3 className="d-inline">Student transfer approvals</h3>
          </div>

          <Filters
            dropdowns={dropdownData}
            filterForm={filterForm}
            getApprovalRequests={getApprovalRequests}
            handleFilterForm={handleFilterForm}
          />

        </div>
        <hr className="my-2" />
        <ApprovalRequestsList
          approvalRequests={approvalRequests}
          updateStatus={updateStatus}
          loading={loading}
          isApprovePermission={isApproverPermission}
          paginationInfo={paginationInfo}
          getApprovalRequests={getApprovalRequests}
        />

        <ApprovalSentSuccessDialog
          open={approvalActionSuccessDialogOpen}
          setOpen={setApprovalActionSuccessDialogOpen}
          heading={approvalActionSuccessDialogInfo?.heading}
          subHeading={approvalActionSuccessDialogInfo?.subHeading}

        />
      </Card>
    </>
  );
};

export default TransferApproval;
